import { render, staticRenderFns } from "./NivelCuatroDetalle.vue?vue&type=template&id=0e4edbbe"
import script from "./NivelCuatroDetalle.vue?vue&type=script&lang=js"
export * from "./NivelCuatroDetalle.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports